module.exports = __webpack_public_path__ + "static/media/business.d5455a04.jpg";